<template>
  <VisaForm country="togo" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields v-model="form.entry" />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <PassportDetailsNotes half-year-valid />
      <StayAddress v-model="form.stayAddress" />
      <EmergencyContactFields v-model="form.emergencyContact" />
      <ApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <AddressFields v-model="applicant.address" />
          <FamilyDetailsFields v-model="applicant.family" has-marital-status />
          <OccupationStatus v-model="applicant.occupation" />
        </template>
      </ApplicantInfo>
    </template>

    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();
</script>